<template>
  <div>
    <c-loader v-if="isDataLoading" label="Загрузка отчётов" :active="isDataLoading" height="500" />
    <div class="reports">
      <div v-for="(item, index) in sortedReportsByFavorite" :id="`chart-${index}`" :key="index" class="reports__chart">
        <template v-if="!isDataLoading && dataReportsLocal.length > 0">
          <div>
            <div class="reports__chart__header">
              <div class="reports__chart__header__title">{{ item.titleChart }}</div>
              <c-button
                size="iconic"
                icon="favorites"
                :tooltip="{ text: 'Добавить в избранное', activeText: 'Добавлено в избранное' }"
                :active="item.isFavorite"
                @click="triggerFavoriteReport(index, item.chartName, item.isFavorite ? 0 : 1)"
              />
            </div>
            <highcharts :options="item.settings" />
          </div>
          <c-sidesheet :active="item.isActiveModalFilial" @close="closeModalFilial(index)">
            <div class="reports__chart__filial__modal">
              <div class="reports__chart__filial__modal__header">
                <svg
                  class="reports__chart__filial__modal__header__close"
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  @click="closeModalFilial(index)"
                >
                  <path
                    d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
                    fill="#8E9CBB"
                  />
                  <path
                    d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
                    fill="#8E9CBB"
                  />
                </svg>
                <div class="reports__chart__filial__modal__header__title">{{ item.titleChart }}</div>
              </div>
              <div
                :class="{ reports__chart__filial__modal__search__shadow: isScrollableCharts }"
                class="reports__chart__filial__modal__search"
              >
                <c-input
                  v-model="filialsLocalSelect"
                  class="reports__chart__filial__modal__search__input"
                  type="select"
                  :checkbox="true"
                  checkbox-type="icon"
                  :checkbox-value="filialsLocalCheckbox"
                  :checkbox-tooltip="{
                    disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                    activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                    notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
                  }"
                  :multiple="true"
                  :searchable="true"
                  placeholder="Все филиалы"
                  :items="getFilialSelectItems(item.filialDataReports)"
                  @checkboxChange="inputSearchCheckboxChange"
                />
                <div class="reports__chart__filial__modal__search__desc">
                  При клике на секторе графика вы перейдете на страницу со списком сотрудников, отфильтрованных по этому
                  признаку
                </div>
              </div>
              <div
                :id="`charts-modal-${index}`"
                class="reports__chart__filial__modal__charts"
                @scroll="handleChartsScroll(index)"
              >
                <div
                  v-for="(filialChart, i) in item.filialDataReports"
                  :key="i"
                  :class="{
                    reports__chart__filial__modal__charts__item__hidden: !isShowFilialDataReportBySearch(filialChart),
                  }"
                  class="reports__chart__filial__modal__charts__item"
                >
                  <div class="reports__chart__filial__modal__charts__item__title">{{ filialChart.filialName }}</div>
                  <highcharts :options="filialChart.settings" />
                </div>
              </div>
            </div>
          </c-sidesheet>
        </template>
      </div>
      <div v-if="!isDataLoading && dataReportsLocal.length === 0" class="reports__empty">Отчёты не найдены</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Chart } from "highcharts-vue";
import Button from "@/components/controls2/Button";
import Loader from "@/components/loader";
import Sidesheet from "@/components/sidesheet";
import Input from "@/components/controls2/Input";
// import exportingInit from "highcharts/modules/exporting";

export default {
  name: "c-table-actions",
  components: {
    "c-button": Button,
    "c-loader": Loader,
    "c-sidesheet": Sidesheet,
    "c-input": Input,
    "highcharts": Chart,
  },
  props: ["enabledFilters"],

  data() {
    return {
      dataLocal: [],
      dataReportsLocal: [],
      globalFilters: [],
      globalFiltersQueryLocal: null,
      isDataLoading: false,
      filialsLocalSelect: [],
      filialsLocalCheckbox: false,
      infoFavoriteReportsLocal: [],
      isScrollableCharts: false,
    };
  },

  computed: {
    ...mapGetters("employees", ["getRecords"]),

    sortedReportsByFavorite() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataReportsLocal.sort((a, b) => {
        if (a.isFavorite === b.isFavorite) {
          return 0;
        }
        if (a.isFavorite) {
          return -1;
        }
        return 1;
      });
    },
  },

  watch: {
    dataLocal(value) {
      this.dataReportsLocal = [];
      let index = 0;
      Object.entries(value).forEach(([chartName, values]) => {
        const vm = this;
        const pieChartSettings = {
          chart: {
            type: "pie",
            height: 420,
            options3d: {
              enabled: true,
              alpha: 45,
            },
            style: {
              fontFamily: "Fira Sans",
            },
            renderTo: `chart-${index}`,
          },
          exporting: {
            buttons: {
              contextButton: {
                enabled: false,
              },
              printButton: {
                enabled: false,
              },
            },
          },
          title: {
            text: "",
          },
          plotOptions: {
            pie: {
              center: [null, 120],
              size: 230,
              allowPointSelect: true,
              cursor: "pointer",
              dataLabels: {
                enabled: false,
              },
              showInLegend: true,
              colors: [
                "#97C1FF",
                "#6396E1",
                "#97F2C7",
                "#F7A35C",
                "#8085E9",
                "#F15C80",
                "#E4D354",
                "#2B908F",
                "#F45B5B",
                "#91E8E1",
                "#979797",
                "#5AB751",
                "#434348",
                "#DD9200",
                "#B90000",
                "#C07ED8",
              ],
            },
            series: {
              animation: false,
              point: {
                events: {
                  click() {
                    if (this.series.userOptions.chartName !== "filials") {
                      vm.openFilialModal(this.series.userOptions.chartIndex);
                    }
                  },
                },
              },
            },
          },
          credits: false,
          series: [],
          tooltip: {
            useHTML: true,
            headerFormat: "{point.point.labelDescription}{point.point.label}<br>",
            pointFormat: "{point.y} <b>{point.percentage:,.1f}%</b>",
          },
          legend: {
            labelFormat: "{label} <b>{y}</b> {percentage:,.1f}%",
            verticalAlign: "top",
            floating: true,
            y: 272,
            padding: 5,
            maxHeight: 200,
            maxWidth: 360,
            itemStyle: "{ \"word-wrap\": \"break-word\"; \"font-weight\": \"normal\"}",
            itemMarginBottom: 10,
          },
        };

        let title = "";

        switch (chartName) {
          case "ages":
            title = "Возраст";
            break;
          case "characteristic":
            title = "Характеристика";
            break;
          case "citizenships":
            title = "Гражданство";
            break;
          case "doc_problems":
            title = "Проблемы с документами по должностям";
            break;
          case "filials":
            title = "Филиалы";
            break;
          case "languages":
            title = "Владения языками";
            break;
          case "posts":
            title = "Должности";
            break;
          case "programs":
            title = "Владение программами";
            break;
          case "quest_completions":
            title = "Заполненность анкеты";
            break;
          case "ranks":
            title = "Разряды";
            break;
          case "schedules":
            title = "График работы";
            break;
          case "specialties":
            title = "Специальность";
            break;
          case "statuses":
            title = "Статусы";
            break;
          case "work_durations":
            title = "Продолжительность работы";
            break;
          case "dismissalReasons":
            title = "Причины увольнений";
            break;
          default:
            break;
        }

        const chartSeries = [];
        let filialDataReports = [];

        Object.entries(values).forEach(([propertyName, value]) => {
          if (propertyName !== "filials") {
            // chartSeries.push({ label: propertyName, y: value.total })
            switch (chartName) {
              case "ages":
                chartSeries.push({ labelDescription: "Возраст: ", label: propertyName, y: value.total });
                break;
              case "schedules":
                chartSeries.push({ labelDescription: "График: ", label: propertyName, y: value.total });
                break;
              case "ranks":
                chartSeries.push({ labelDescription: "Разряд: ", label: propertyName, y: value.total });
                break;
              default:
                chartSeries.push({ labelDescription: "", label: propertyName, y: value.total });
                break;
            }
          } else {
            filialDataReports = [];
            Object.entries(value).forEach(([filialName, filialData]) => {
              const filialPieChartSettings = JSON.parse(JSON.stringify(pieChartSettings));
              filialPieChartSettings.plotOptions.series.point = {
                events: {
                  click() {
                    vm.goToWorkersTable(
                      this.series.userOptions.filialId,
                      this.series.userOptions.chartName,
                      this.itemId,
                      this.range !== undefined ? this.range : {},
                    );
                  },
                },
              };

              filialPieChartSettings.series = [];
              const filialChartSeries = [];

              Object.entries(filialData.data).forEach(([label, val]) => {
                switch (chartName) {
                  case "work_durations":
                    filialChartSeries.push({ label, itemId: val.id, y: val.total, range: val.range });
                    break;
                  case "ages":
                    filialChartSeries.push({ labelDescription: "Возраст: ", label, itemId: val.id, y: val.total });
                    break;
                  case "ranks":
                    filialChartSeries.push({ labelDescription: "Разряд: ", label, itemId: val.id, y: val.total });
                    break;
                  case "schedules":
                    filialChartSeries.push({ labelDescription: "График: ", label, itemId: val.id, y: val.total });
                    break;
                  default:
                    filialChartSeries.push({ labelDescriptions: "", label, itemId: val.id, y: val.total });
                    break;
                }
              });

              if (filialChartSeries.length > 0) {
                if (chartName === "ranks") {
                  filialPieChartSettings.series.push({
                    chartName,
                    name: filialName,
                    filialId: filialData.id,
                    data: filialChartSeries.sort((a, b) => b.y - a.y),
                  });
                } else {
                  filialPieChartSettings.series.push({
                    chartName,
                    name: filialName,
                    filialId: filialData.id,
                    data: filialChartSeries,
                  });
                }

                filialDataReports.push({ filialName, filialId: filialData.id, settings: filialPieChartSettings });
              }
            });
          }
        });

        if (chartSeries.length > 0) {
          const indexFavoriteReport = this.infoFavoriteReportsLocal.findIndex((chart) => chart.name === chartName);
          const isFavoriteReport = this.infoFavoriteReportsLocal[indexFavoriteReport].is_favorite.toString() === "1";

          if (chartName === "ranks") {
            pieChartSettings.series.push({
              name: "",
              chartName,
              chartIndex: chartName,
              data: chartSeries.sort((a, b) => b.y - a.y),
            });
          } else {
            pieChartSettings.series.push({ name: "", chartName, chartIndex: chartName, data: chartSeries });
          }

          this.dataReportsLocal.push({
            chartName,
            titleChart: title,
            settings: pieChartSettings,
            isActiveModalFilial: false,
            isFavorite: isFavoriteReport,
            filialDataReports,
          });
        }
        index += 1;
      });
    },

    enabledFilters(value) {
      const activeGlobalFilters = [];

      value.forEach((item) => {
        const c = activeGlobalFilters.findIndex((i) => i.id === item.id);

        if (c === -1 && item.type === "number" && item.searchType === "4" && item.value.end !== 0) {
          activeGlobalFilters.push(item);
        }

        if (c !== -1 && item.type === "number" && item.searchType === "4" && item.value.end !== 0) {
          activeGlobalFilters[c] = item;
        }

        if (c === -1 && item.type === "boolean" && item.value) {
          activeGlobalFilters.push(item);
        }

        if (c !== -1 && item.type === "boolean") {
          if (item.value === "1") {
            activeGlobalFilters[c] = item;
          }
          if (item.value === "0") {
            activeGlobalFilters.splice(c, 1);
          }
        }

        if (c !== -1 && item.value.length === 0 && item.type !== "boolean") {
          activeGlobalFilters.splice(c, 1);
        } else if (c !== -1 && item.value.length > 0 && item.type !== "boolean") {
          activeGlobalFilters[c] = item;
        } else if (c === -1 && item.value.length > 0 && item.type !== "boolean") {
          activeGlobalFilters.push(item);
        }
      });

      this.globalFilters = [...activeGlobalFilters];
    },

    globalFilters(value) {
      if (!this.isDataLoading) {
        const queryFilters = value.reduce((acc, item) => {
          let currentFilter;
          if (item.type === "list") {
            currentFilter = {
              [item.id]: item.value.map((i) => i.id).join(","),
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "number" && item.searchType === "4") {
            currentFilter = {
              [item.id]: `${item.value.start},${item.value.end}`,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "boolean") {
            if (item.value === "1") {
              currentFilter = {
                [item.id]: item.value,
                [`${item.id}_filterType`]: item.type,
              };
            }
          } else {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          }
          return { ...acc, ...currentFilter };
        }, {});

        this.globalFiltersQueryLocal = queryFilters;

        const fullQuery = {
          sortBy: "created",
          sortType: "desc",
          ...queryFilters,
        };

        this.$emit("setTabsQuery", queryFilters);

        if (JSON.stringify(this.$route.query) !== JSON.stringify(fullQuery)) {
          this.isDataLoading = true;
          this.$store
            .dispatch("employees/getRecords", [
              0,
              fullQuery.sortBy,
              fullQuery.sortType,
              { globalFilters: [...value], localFilters: [] },
              0,
              "diagram",
            ])
            .then((result) => {
              this.dataLocal = result;
            })
            .finally(() =>
              setTimeout(() => {
                this.$router
                  .replace({
                    name: "employees-reports",
                    query: fullQuery,
                  })
                  .catch(() => {});

                this.isDataLoading = false;
              }, 300),
            );
        }
      }
    },

    filialsLocalSelect(value) {
      if (value.length === 0) {
        this.filialsLocalCheckbox = false;
      }
    },
  },

  async created() {
    this.isDataLoading = true;

    this.$store.dispatch("employees/getAllFilters").then((res) => {
      res.forEach((field) => {
        if (this.$route.query[`${field.code}_global`] !== undefined) {
          let filterOptions;

          if (this.$route.query[`${field.code}_global_filterType`] === "list") {
            const values = this.$route.query[`${field.code}_global`].split(",").map((item) => ({ id: item }));
            filterOptions = {
              id: `${field.code}_global`,
              type: this.$route.query[`${field.code}_global_filterType`],
              searchType: this.$route.query[`${field.code}_global_searchType`],
              value: values,
            };
          } else if (
            this.$route.query[`${field.code}_global_filterType`] === "number" &&
            this.$route.query[`${field.code}_global_searchType`] === "4"
          ) {
            const values = this.$route.query[`${field.code}_global`].split(",");
            const rangeVal = { start: values[0], end: values[1] };
            filterOptions = {
              id: `${field.code}_global`,
              type: this.$route.query[`${field.code}_global_filterType`],
              searchType: this.$route.query[`${field.code}_global_searchType`],
              value: rangeVal,
            };
          } else if (this.$route.query[`${field.code}_global_filterType`] === "boolean") {
            filterOptions = {
              id: `${field.code}_global`,
              type: this.$route.query[`${field.code}_global_filterType`],
              value: this.$route.query[`${field.code}_global`],
            };
          } else {
            filterOptions = {
              id: `${field.code}_global`,
              type: this.$route.query[`${field.code}_global_filterType`],
              searchType: this.$route.query[`${field.code}_global_searchType`],
              value: this.$route.query[`${field.code}_global`],
            };
          }
          this.globalFilters.push(filterOptions);
        }
      });

      this.$store.dispatch("employees/getInfoAboutFavoritesReports").then((result) => {
        this.infoFavoriteReportsLocal = result.response;

        this.$emit("ready");

        this.$store
          .dispatch("employees/getRecords", [
            0,
            "created",
            "desc",
            { localFilters: [], globalFilters: [...this.globalFilters] },
            0,
            "diagram",
          ])
          .then((result) => {
            setTimeout(() => {
              this.$emit("globalFiltersActive");
            }, 400);

            this.dataLocal = result;

            this.isDataLoading = false;
          });
      });
    });
  },

  methods: {
    handleChartsScroll(index) {
      const element = document.getElementById(`charts-modal-${index}`);
      if (element !== null) {
        if (element.scrollHeight > element.clientHeight && element.scrollTop !== 0) {
          this.isScrollableCharts = true;
          return;
        }
      }
      this.isScrollableCharts = false;
    },

    closeModalFilial(index) {
      this.dataReportsLocal[index].isActiveModalFilial = false;
      setTimeout(() => {
        this.filialsLocalSelect = [];
        this.filialsLocalCheckbox = false;
        this.isScrollableCharts = false;
      }, 200);
    },

    openFilialModal(chartName) {
      const c = this.dataReportsLocal.findIndex((report) => report.chartName === chartName);
      this.dataReportsLocal[c].isActiveModalFilial = true;
    },

    getFilialSelectItems(filialSettings) {
      return filialSettings.map((filial) => ({
        value: filial.filialId,
        label: filial.filialName,
        id: filial.filialId,
      }));
    },

    isShowFilialDataReportBySearch(filialReport) {
      if (this.filialsLocalSelect.length === 0) {
        return true;
      }
      const filialIds = this.filialsLocalSelect.map((filial) => filial.id);
      if (!this.filialsLocalCheckbox) {
        return filialIds.includes(Number(filialReport.filialId));
      }
      return !filialIds.includes(filialReport.filialId);
    },

    inputSearchCheckboxChange(val) {
      this.filialsLocalCheckbox = val;
    },

    goToWorkersTable(filialId, chartName, filterKey, range) {
      const currentSearchQuery = this.$route.query;
      let queryWithFilter;
      switch (chartName) {
        case "ages":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            age_global: filterKey,
            age_global_filterType: "list",
            age_global_searchType: 1,
          };
          break;
        case "characteristic":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            characteristic: filterKey,
            characteristic_filterType: "list",
            characteristic_searchType: 1,
          };
          break;
        case "citizenships":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            citizenship: filterKey.toString() === "0" ? "undefined" : filterKey,
            citizenship_filterType: "list",
            citizenship_searchType: 1,
          };
          break;
        case "doc_problems":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            postCategorySpecialty: filterKey,
            postCategorySpecialty_filterType: "list",
            postCategorySpecialty_searchType: 1,
            docProblem_global: 1,
            docProblem_global_filterType: "boolean",
          };
          break;
        case "languages":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            langs_global: filterKey,
            langs_global_filterType: "list",
            langs_global_searchType: 1,
          };
          break;
        case "posts":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            postCategorySpecialty: filterKey,
            postCategorySpecialty_filterType: "list",
            postCategorySpecialty_searchType: 1,
          };
          break;
        case "programs":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            programs_global: filterKey,
            programs_global_filterType: "list",
            programs_global_searchType: 1,
          };
          break;
        case "quest_completions":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            questCompletion_global: filterKey,
            questCompletion_global_filterType: "list",
            questCompletion_global_searchType: 1,
          };
          break;
        case "ranks":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            category: filterKey,
            category_filterType: "list",
            category_searchType: 1,
          };
          break;
        case "schedules":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            schedule: filterKey,
            schedule_filterType: "list",
            schedule_searchType: 1,
          };
          break;
        case "specialties":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            specialty_global: filterKey == null ? "undefined" : filterKey,
            specialty_global_filterType: "list",
            specialty_global_searchType: 1,
          };
          break;
        case "statuses":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            workerStatus: filterKey,
            workerStatus_filterType: "list",
            workerStatus_searchType: 1,
          };
          break;
        case "work_durations":
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: "list",
            filial_searchType: 1,
            workDuration_global: `${range.start},${range.finish}`,
            workDuration_global_filterType: "number",
            workDuration_global_searchType: 4,
          };
          break;
        case 'dismissalReasons':
          queryWithFilter = {
            ...currentSearchQuery,
            filial: filialId,
            filial_filterType: 'list',
            filial_searchType: 1,
            dismissalReason: filterKey,
            dismissalReason_filterType: "list",
            dismissalReason_searchType: 1,
          }
          break          
        default:
          break;
      }

      const routeData = this.$router.resolve({ name: "employees-list", query: queryWithFilter });
      window.open(routeData.href, "_blank");
    },

    triggerFavoriteReport(chartIndex, chartName, chartStatus) {
      const params = { chartName, chartStatus };
      this.$store.dispatch("employees/addOrRemoveReportToFavorites", params).then(() => {
        this.dataReportsLocal[chartIndex].isFavorite = chartStatus.toString() === "1";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.reports {
  position: relative;
  padding-top: 14px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  @media screen and (max-width: 600px) {
    &:after {
      content: "";
      position: fixed;
      z-index: 1000;
      bottom: 0;
      width: 100%;
      height: 24px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
    }
  }

  @media screen and (max-width: 870px) {
    justify-content: center;
  }

  &__chart {
    cursor: pointer;
    border: 1px solid #dfe4ef;
    min-width: 400px;
    margin-top: -1px;
    margin-left: -1px;
    min-height: 470px;
    height: 100%;
    padding: 20px 15px 0 15px;

    @media screen and (max-width: 1200px) {
      min-width: 50%;
      width: 50%;
    }

    @media screen and (max-width: 600px) {
      width: calc(100% + 40px);
      min-width: calc(100% + 40px);
      border-right: none;
      border-left: none;
    }

    &__header {
      display: flex;
      justify-content: space-between;

      &__title {
        font-family: Fira Sans;
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
        color: #000000;
      }
    }

    &__filial__modal {
      height: 100%;

      @media screen and (max-width: 700px) {
        padding: 0;
      }

      &__header {
        display: flex;
        justify-content: space-between;

        @media screen and (max-width: 768px) {
          flex-direction: column;
        }

        &__close {
          position: absolute;
          top: 12px;
          right: 12px;
          display: none;

          @media screen and (max-width: 768px) {
            display: block;
          }
        }

        &__title {
          font-style: normal;
          font-weight: 500;
          font-size: 22px;
          line-height: 108%;
          color: #000000;

          @media screen and (max-width: 768px) {
            font-size: 18px;
          }
        }
      }

      &__search {
        margin-top: 25px;
        display: flex;
        position: relative;
        justify-content: space-between;

        @media screen and (max-width: 768px) {
          flex-direction: column;
          margin-right: 20px;
        }

        @media screen and (max-width: 700px) {
          margin-right: 0;
        }

        &__input {
          width: 50%;
          margin-right: 30px;

          @media screen and (max-width: 768px) {
            margin-right: 0;
            width: 100%;
          }
        }

        &__desc {
          font-family: Fira Sans;
          font-style: normal;
          font-weight: normal;
          font-size: 11px;
          position: relative;
          line-height: 108%;
          color: #8e9cbb;
          margin-right: 30px;

          @media screen and (max-width: 768px) {
            margin-right: 0;
            margin-top: 13px;
          }
        }

        &__shadow:after {
          content: "";
          position: absolute;
          background: -webkit-gradient(
            linear,
            left bottom,
            left top,
            color-stop(16.13%, rgba(255, 255, 255, 0)),
            color-stop(100%, #ffffff)
          );
          bottom: -54px;
          left: -20px;
          height: 24px;
          z-index: 1000;
          width: calc(100% + 40px);
        }
      }

      &__charts {
        margin-top: 30px;
        width: 100%;
        height: calc(100% - 40px);
        overflow-y: auto;
        align-content: flex-start;
        display: flex;
        flex-wrap: wrap;
        padding: 1px;

        @media screen and (max-width: 700px) {
          justify-content: center;
          width: calc(100% + 40px);
          margin-left: -20px;
        }

        &__item {
          cursor: pointer;
          border: 1px solid #dfe4ef;
          min-width: calc(33% - 4px);
          max-height: 460px;
          margin-top: -1px;
          margin-left: -1px;
          height: 100%;
          padding: 20px 15px 0 15px;
          visibility: visible;
          opacity: 1;
          transition: 0.3s;

          @media screen and (max-width: 1000px) {
            width: calc(50% - 6px);
          }

          @media screen and (max-width: 650px) {
            border-right: 0;
            border-left: 0;
            width: 100%;
            min-width: 100%;
          }

          &__title {
            font-family: Fira Sans;
            font-weight: 500;
            font-size: 15px;
            line-height: 18px;
            color: #000000;
          }

          &__hidden {
            position: absolute;
            opacity: 0;
            transition: 0.3s;
            visibility: hidden;
          }
        }

        &::-webkit-scrollbar {
          width: 4px;
          height: 100%;
        }

        &::-webkit-scrollbar-thumb {
          background: $color-secondary;
          border-radius: 4px;
        }

        &::-webkit-scrollbar-track {
          background: $color-border-alt;
        }
      }
    }
  }

  &__empty {
    display: flex;
    width: 100%;
    height: 500px;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    line-height: 18px;
    border: 1px solid #dfe4ef;
  }
}

::v-deep .sidesheet__wrapper {
  width: calc(100vw - 161px);
  //max-width: 1800px;
  //right: -100%;
  padding-right: 15px;

  @media screen and (max-width: 1024px) {
    width: calc(100vw - 62px);
  }

  @media screen and (max-width: 768px) {
    padding: 30px 15px 30px 30px;
    max-width: 100%;
    width: 100%;
  }

  @media screen and (max-width: 700px) {
    padding: 20px;
  }
}

::v-deep .sidesheet__wrapper_active {
  right: 0 !important;
}

::v-deep .sidesheet__wrapper_active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 24px;
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
}

::v-deep .sidesheet__header {
  flex-basis: 0;
}
</style>
